import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { ErrorPageLayout } from 'components/Layout/ErrorPageLayout';
import { ErrorMessage } from '../components/ErrorMessage';
import { BackButton } from '../components/BackButton';
import { LoginButton } from '../components/LoginButton';

import { ReactComponent as UnauthorizedImage } from '../img/unauthorized.svg';

const m = defineMessages({
  header: {
    id: 'Errors.ErrorPage.Unauthorized.Header',
    defaultMessage: "Oups...tu n'es pas autorisé",
  },
  subHeader: {
    id: 'Errors.ErrorPage.Unauthorized.SubHeader',
    defaultMessage: 'Réessayez avec un autre compte.',
  },
});

export const UnauthorizedError: React.FC = () => {  
  const { formatMessage } = useIntl();  

  const buttons = (
    <>
      <BackButton basic primary />
      <LoginButton primary />
    </>
  );  

  return (
    <ErrorPageLayout>
      <ErrorMessage
        headerMessage={formatMessage(m.header)}
        subHeaderMessage={formatMessage(m.subHeader)}
        errorImage={UnauthorizedImage}
        buttons={buttons}
      />
    </ErrorPageLayout>
  );
};
